<template>
  <div id="generic-lodgings-display">
    <div class="row row-hubs">
      <div class="container-fluid position-relative">
        <div class="d-flex flex-row flex-nowrap" ref="scroller" style="overflow: scroll; overflow-y: hidden" :class="withDiscountBadges  && !isPhone ? 'mx-5' : ''">
          <div class="card card-body border-0" v-if="lodgings"  v-for="lodging in lodgings" :key="`nearby-${lodging.id}`" style="min-height: auto; min-width: auto; max-width: fit-content;">
            <CardProductHome :user="user || {}" data-aos="fade-up" data-aos-duration="900" :lodging="lodging" :lodgings="lodgings" :showDiscountBadges="withDiscountBadges" :showOnMap="withDiscountBadges"></CardProductHome>
          </div>
        </div>
        <div class="flex-shrink-0 previous-slide-button circle-icon" @click="scroll_left">
          <img src="../../images/arrow-left-black.svg" alt="Previous" />
        </div>
        <div class="flex-shrink-0 next-slide-button circle-icon"@click="scroll_right">
          <img src="../../images/arrow-right-black.svg" alt="Next" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardProductHome from "../../components/cards/CardProductHome.vue";
import AOS from "aos";

export default {
  name: 'GenericLodgingsDisplay',
  components: { CardProductHome },
  props: ['user', 'lodgings', 'withDiscountBadges'],
  data() {
    return {
      isPhone: window.innerWidth <= 768,
    };
  },
  mounted() {
    AOS.init();
    this.autoScroll();
  },
  methods: {
    autoScroll() {
      const scroller = this.$refs.scroller;
      const step = 1; // Adjust step for speed
      let maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

      const frame = () => {
        if (scroller.scrollLeft >= maxScrollLeft) {
          scroller.scrollLeft = 0; // Reset scroll to start when it reaches the end
          maxScrollLeft = scroller.scrollWidth - scroller.clientWidth; // Recalculate in case of dynamic content
        } else {
          scroller.scrollLeft += step;
        }
        requestAnimationFrame(frame);
      }
      frame();
    },
    scroll_left() {
      this.$refs.scroller.scrollLeft -= 220;
    },
    scroll_right() {
      this.$refs.scroller.scrollLeft += 220;
    }
  }
};
</script>

<style scoped>
#generic-lodgings-display {
  .header-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    gap: 40px;

    @media screen and (max-width: 767px) {
      gap: 15px;
      overflow-x: auto;
      align-items: start;
      justify-content: start;
    }

    .header-nav-tabs {
      cursor: pointer;
      color: #524F4FDD;

      div {
        white-space: nowrap;
        padding: 0.5rem 1rem;

        @media screen and (max-width: 767px) {
          padding: 0.5rem 0.5rem 0.5rem 0px;
        }
      }
    }
  }

  .hub-img, .hub-img-zoom {
    width: 334px !important;
    height: 277px !important;
    border-radius: 15px;
  }

  .hub-img {
    border-radius: 15px;

    img { 
      border-radius: 15px;
    }
  }

  .hub-img-zoom {
    border-radius: 15px;

    img { 
      border-radius: 15px;
    }
  }
}

.circle-icon {
  width: 44px;
  height: 46px;
  border: 1px solid #F7F7F7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media screen and (max-width: 767px) {
    width: 35px;
    height: 35px;
    img {
      width: 20px;
    }
    
  }
}
.previous-slide-button {
  position: absolute;
  top: 30%;
  transform: translateY(-50%);
  left: 15px;
  color: #F7F7F7;
  background-color: #F7F7F7;

  i {
    color: black;
  }
}

.next-slide-button {
  position: absolute;
  top: 30%;
  transform: translateY(-50%);
  right: 15px;
  color: #F7F7F7;
  background-color: #F7F7F7;

  i {
    color: black;
  }
}

.card-body {
  padding: 0;
}

</style>